import * as React from "react"
import { Badge, Box } from "@mui/material"

import {USER_ROLES} from "@constants";
import {userData} from "@signals";


export default function assortmentColumn() {
	return [{
		name: 'assortment', label: userData.value.role === USER_ROLES.RETAILER ? 'Affinity' : 'Assortment',
		options: {
			display: 'excluded',
			customBodyRowRender: value => value ? 'Yes' : 'No'
		}
	}, {
		name: 'assortment', label: 'Assortment',
		options: {
			filter: false,
			customBodyRowRender: value => {
				return <Box sx={{ textAlign: 'center' }}>
					<Badge color={value ? 'success' : 'error'} badgeContent=" " />
				</Box>
			}
		}
	}]
}